import { useState } from 'react'
import {
  Play,
  RotateCcw,
  Upload,
  CheckCircle2,
  Copy
} from 'lucide-react'

import Breadcrumb from '../../components/layout/Breadcrumb'

import {
  Card,
  CardHeader,
  CardBody,
  PageHeader,
  Alert,
  Spinner,
} from '../../components/ui'

import { useRunRegression } from '../../hooks/useRegression'

export default function RunRegressionPage() {

  const mutation = useRunRegression()

  const [file, setFile] = useState(null)
  const [stateCode, setStateCode] = useState('TX')

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!file) {
      return
    }

    mutation.mutate({
      file,
      stateCode,
    })
  }

  const handleReset = () => {
    setFile(null)
    setStateCode('TX')
    mutation.reset()
  }
  const [copied, setCopied] = useState(false)
  const handleCopyReference = async () => {
    await navigator.clipboard.writeText(
      mutation.data?.referenceNumber || ''
    )

  setCopied(true)

  setTimeout(() => {
    setCopied(false)
  }, 2000)
}

  return (
    <div className="animate-fade-in space-y-6">

      <Breadcrumb />

      <PageHeader
        title="Run Regression"
        description="Upload a regression file and execute regression processing"
      />

      <Card className="border-l-[6px] border-l-blue-500">

        <CardHeader>
          <h2 className="section-title">
            Regression Parameters
          </h2>

          <p className="text-sm text-slate-500 mt-1">
            Upload an Excel file and choose a state.
          </p>
        </CardHeader>

        <CardBody>

          <form onSubmit={handleSubmit}>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-6">

              {/* File Upload */}
              <div>
                <label className="block text-sm font-medium mb-2">
                  Regression File
                </label>

                <input
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={(e) => setFile(e.target.files?.[0])}
                  className="block w-full border rounded-lg p-2"
                />
              </div>

              {/* State Dropdown */}
              <div>
                <label className="block text-sm font-medium mb-2">
                  State Code
                </label>

                <select
                  value={stateCode}
                  onChange={(e) => setStateCode(e.target.value)}
                  className="w-full border rounded-lg p-2"
                >
                  <option value="TX">TX</option>
                  <option value="CA">CA</option>
                </select>
              </div>

            </div>

            <div className="flex gap-3">

              <button
                type="submit"
                disabled={mutation.isPending || !file}
                className="btn-primary"
              >
                {mutation.isPending ? (
                  <>
                    <Spinner size="sm" />
                    Running...
                  </>
                ) : (
                  <>
                    <Play className="h-4 w-4" />
                    Run Regression
                  </>
                )}
              </button>

              <button
                type="button"
                onClick={handleReset}
                className="btn-secondary"
              >
                <RotateCcw className="h-4 w-4" />
                Reset
              </button>

            </div>

          </form>

        </CardBody>
      </Card>

      {/* Error */}
     {mutation.isError && (
        <Alert type="error" title="Regression Failed">
        </Alert>
      )}

      {/* Success */}
      {mutation.isSuccess && (
        <Card>
          <CardBody>
              <div>
             <div className="animate-fade-in flex items-start gap-3 rounded-lg border border-green-200 bg-green-50 p-4 shadow-sm">
                {/* Icon */}
                <div className="flex-shrink-0">
                  <svg
                    className="h-5 w-5 text-green-600 mt-0.5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>

                {/* Content */}
                <div>
                  <p className="text-sm font-semibold text-green-700">
                    Success
                  </p>
                  <p className="mt-1 text-sm text-green-600">
                    {mutation.data?.message}
                  </p>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      )}
    </div>
  )
}